import type { PersistedState } from 'redux-persist';

/**
 * Drops a security dashboard saved by an older release. The slice is no longer
 * persisted, but the blacklist only stops future saves, and an old copy can
 * lack fields the dashboard now reads.
 */
export const withoutSecurityDashboard = (state: PersistedState): PersistedState => {
    if (!state || !('securityDashboard' in state)) {
        return state;
    }
    return Object.fromEntries(
        Object.entries(state).filter(([key]) => key !== 'securityDashboard'),
    ) as PersistedState;
};

export default withoutSecurityDashboard;
